module.exports = __webpack_public_path__ + "img/低压堆叠电池组.0c563c5b.png";